import Hosts from '../../../Hosts';

const object_type = 'store/product'

const api_crud_base = Hosts.SIMCore_API
const api_crud_route = `${Hosts.SIMCore_API}/${object_type}`
const api_list_route = (companycode) => `${Hosts.SIMCore_API}/${object_type}/${companycode}`

const base_endpoint = '/store_product'

const endpoints = {
    base: base_endpoint,
    regist: `${base_endpoint}_regist`,
    list: `${base_endpoint}_list`,
    view: `${base_endpoint}_view`,
}

const data_interface = {
    id: '',
    info: {
        companycode: '',
        reference: '',
        name: '',
        type: 'standard',  // standard; pack; virtual
        date: {
            creation: '',
            published: '',
            avaiable: '',
            modified: []
        },
        language: [],
        media: {
            id: '',
            link: '',
        },  
        seo: {
            title: '',
            description: '',
            keywords: '',
            language: []
        }, 
        category: [],
        features: [],
        brands: [],
        related: [],
        base: {
            price: '',
            stock: '',
            tax: '',
        },
        quantity: [{
            units: '',
            minimum_for_sale: '1',
            stock: '',
            price: '',
            tax: '',
            image: '',
            low_stock_warning: '',
            low_stock_email_warning: false,
            stock_out: 'deny', // deny || allow || 
            label_in_stock: '',
            label_out_stock: ''
        }],
        combination: [],
        shipping: {
            width: '0',
            height: '0',
            depth: '0',
            weight: '0',
            carrier: []
        },
        order: '1',
        slug: '',           // friendly url
        status: false
    },
    content: [{
        title: '',
        description: '',
        text: '',
        media: {
            image: [],
            doc: []
        },
        language: []
    }]
}

export {
    endpoints,
    api_crud_base,
    api_crud_route,
    data_interface,
    api_list_route
}
